import React from 'react';
import { PrimaryButtonLightBg } from 'apps/sigma2-ui/src/components/PrimaryButtonLightBg';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

export interface FilterApplyButtonProps {
  /**
   * The count to use for the apply button
   */
  appliedCount: number;

  /**
   * Whether or not the apply button is disabled
   */
  disabled: boolean;

  /**
   * Callback when the apply button is clicked
   */
  onApply: () => void;
}

export const FilterApplyButton = ({
  appliedCount,
  disabled,
  onApply,
}: FilterApplyButtonProps) => {
  const language = useLanguage();

  return (
    <PrimaryButtonLightBg
      onClick={() => {
        onApply();
      }}
      disabled={disabled}
      translatedContent={language.filterApplyButton({ count: disabled ? 0 : appliedCount })}
      className={'w-full'}
    />
  );
};
